import { withCompController } from '@wix/editor-elements-integrations';
import type { TextOnPathStateValues } from '../TextOnPath.types';

export default withCompController<
  Record<string, any>,
  Record<string, any>,
  never,
  TextOnPathStateValues
>(({ stateValues, mapperProps }) => {
  const { reducedMotion } = stateValues;
  return {
    ...mapperProps,
    reducedMotion,
  };
});
